<template>
    <div>
        <div style="height: 1px; width: 100%; background: #CCCCCC; margin-top: 17px"></div>

        <a-steps :current="currentStep" style="margin-top: 20px">
            <a-step v-for="status in groupedStatus" :title="status.title" />
        </a-steps>

        <div v-if="data" class="container">

            <!-- Status awal / belum booking DPJP atau DPJP menolak -->
            <div v-if="data.trx_status === '0-init' || data.trx_status === '1-rejected' || data.trx_status === '1-canceled'">

                <template v-if="data.is_partner">
                    <div style="text-align: center" class="mb-10">
                        <div class="text-info">Mohon tunggu partner koas membooking DPJP</div>
                    </div>
                </template>

                <template v-else>
                    <div v-if="data.trx_status === '1-rejected'" style="text-align: center" class="mb-10">
                        <div class="text-info text-info-error">{{ data.log[data.log.length - 1].description }}</div>
                    </div>

                    <div v-if="data.trx_status === '1-canceled'" style="text-align: center" class="mb-10">
                        <div class="text-info text-info-error">{{ data.log[data.log.length - 1].description }}. Silahkan booking kembali</div>
                    </div>

                    <a-row>
                        <a-col
                            :span="24"
                            :md="12"
                            :sm="24"
                            :xs="24"
                        >

                            <small class="item-label"><sup>*</sup> Silahkan pilih klinik</small><br>
                            <a-select
                                class="mt-5"
                                style="width: 100%"
                                v-model="form.department_code"
                                placeholder="- Pilih Klinik -"
                            >
                                <a-select-option
                                    v-for="dep in departements"
                                    :key="dep.id"
                                    :value="dep.id"
                                >
                                    {{ dep.nama_departemen }}
                                </a-select-option>
                            </a-select>
                        </a-col>
                    </a-row>

                    <a-row class="mt-10">
                        <a-col
                            :span="24"
                            :md="12"
                            :sm="24"
                            :xs="24"
                        >
                            <small class="item-label"><sup>*</sup> Silahkan pilih DPJP</small>

                            <a-select class="mt-5" style="width:100%;" v-model="form.dpjp_code" placeholder="- Pilih DPJP -">
                                <a-select-option v-for="dokter in filteredDokter"
                                                 :key="dokter.id" :value="dokter.id">
                                    {{ dokter.nama }}
                                </a-select-option>
                            </a-select>

                        </a-col>
                    </a-row>

                    <a-button class="mt-10" type="primary" @click="bookDpjp()">
                        Booking DPJP
                    </a-button>
                </template>
            </div>

            <!-- DPJP membatalkan di belakang -->
            <div v-if="data.trx_status === '1-late-canceled'">
                <template v-if="data.is_partner">
                    <div style="text-align: center" class="mb-10">
                        <div class="text-info">Mohon tunggu partner koas membooking DPJP</div>
                    </div>
                </template>

                <template v-else>
                    <div style="text-align: center" class="mb-10">
                        <div class="text-info text-info-error">{{ data.log[data.log.length - 1].description }}. Silahkan booking DPJP yang lain</div>
                    </div>

                    <a-row class="mt-10">
                        <a-col
                            :span="24"
                            :md="12"
                            :sm="24"
                            :xs="24"
                        >
                            <small class="item-label"><sup>*</sup> Silahkan pilih DPJP</small>

                            <a-select class="mt-5" style="width:100%;" v-model="form.dpjp_code" placeholder="- Pilih DPJP -">
                                <a-select-option v-for="dokter in filteredDokter"
                                                 :key="dokter.id" :value="dokter.id">
                                    {{ dokter.nama }}
                                </a-select-option>
                            </a-select>

                        </a-col>
                    </a-row>

                    <a-button class="mt-10" type="primary" @click="bookDpjp(true)">
                        Booking DPJP
                    </a-button>
                </template>
            </div>

            <!-- Status menunggu persetujuan DPJP -->
            <div v-if="data.trx_status=='1-request'" style="text-align: center; margin-top: 20px">
                <template v-if="data.is_partner">
                    <div style="text-align: center" class="mb-10">
                        <div class="text-info">Mohon tunggu partner koas membooking DPJP</div>
                    </div>
                </template>

                <template v-else>
                    <div style="text-align: center" class="mb-10">
                        <div class="text-info">Mohon untuk menunggu persetujuan dari DPJP</div>
                    </div>

                    <a-button class="mt-10" type="primary" @click="cancelDpjp()">
                        Batalkan Booking DPJP
                    </a-button>
                </template>
            </div>

            <!-- Status menunggu persetujuan DPJP (sebelumnya dibatalkan DPJP) -->
            <div v-if="data.trx_status=='1-late-request'" style="text-align: center; margin-top: 20px">
                <template v-if="data.is_partner">
                    <div style="text-align: center" class="mb-10">
                        <div class="text-info">Mohon tunggu partner koas membooking DPJP</div>
                    </div>
                </template>

                <template v-else>
                    <div style="text-align: center" class="mb-10">
                        <div class="text-info">Mohon untuk menunggu persetujuan dari DPJP</div>
                    </div>

                    <a-button class="mt-10" type="primary" @click="cancelDpjp()">
                        Batalkan Booking DPJP
                    </a-button>
                </template>
            </div>

            <!-- DPJP telah menyetijui. Mulai pengajuan kasus atau DPJP menolak kasus -->
            <div v-if="data.trx_status === '1-accepted' || data.trx_status === '3-case-rejected'">

                <template v-if="data.wait_for_case">
                    <div style="text-align: center" class="mb-10 vertical-flex flex-center">
                        <EditCase
                            v-if="isEditingCase"
                            :data="data"
                            :teaching-materials="filteredTeachingMaterials(data.departement_code, data)"
                            :auto-save="true"
                            @cancel="isEditingCase = false"
                            @save="onCaseChange"
                        />

                        <template v-else>
                            <div class="text-info">Mohon tunggu partner memilih kasus</div>

                            <a-button class="mt-10" type="secondary" @click="isEditingCase = true">
                                Edit / Tambah Kasus
                            </a-button>
                        </template>
                    </div>
                </template>

                <template v-else>
                    <div v-if="data.trx_status === '1-accepted'" style="text-align: center" class="mb-10 vertical-flex">
                        <div class="text-info text-info-success">DPJP telah menerima permintaan booking</div>
                        <div v-if="!data.is_partner && !data.koas_resident_code2" class="text-info text-info-warning">
                            Jangan lupa klik tombol partner koas bila akan berpasangan!!!
                        </div>
                    </div>

                    <div v-if="data.trx_status === '3-case-rejected'" style="text-align: center" class="mb-10">
                        <div class="text-info text-info-error">{{ data.log[data.log.length - 1].description }}</div>
                    </div>

                    <EditCase
                        :create="true"
                        save-button-text="Ajukan Kasus"
                        :show-cancel-button="false"
                        :data="data"
                        :teaching-materials="filteredTeachingMaterials(data.departement_code, data)"
                        @cancel="isEditingCase = false"
                        @save="requestCase($event, data.trx_status === '3-case-rejected')"
                    />
                </template>
            </div>

            <!-- Status menunggu pasien diadmisi -->
            <div v-if="data.trx_status=='2-accepted'" style="text-align: center; margin-top: 20px; display: flex; flex-direction: column; align-items: center">

                <EditCase
                    v-if="isEditingCase"
                    :data="data"
                    :teaching-materials="filteredTeachingMaterials(data.departement_code, data)"
                    :auto-save="true"
                    @cancel="isEditingCase = false"
                    @save="onCaseChange"
                />

                <template v-else>
                    <div class="text-info">Mohon untuk menunggu pasien diadmisi</div>

                    <a-button class="mt-10" type="secondary" @click="isEditingCase = true">
                        Edit / Tambah Kasus
                    </a-button>
                </template>
            </div>

            <!-- Status menunggu indikasi DPJP -->
            <div
                v-if="!data.is_partner && data.trx_status=='3-admitted' || data.is_partner && data.partner_trx_status === '3-admitted'"
                style="text-align: center; margin-top: 20px; display: flex; flex-direction: column; align-items: center">

                <EditCase
                    v-if="isEditingCase && !canOpenWorkingFormat()"
                    :data="data"
                    :teaching-materials="filteredTeachingMaterials(data.departement_code, data)"
                    :can-edit-former="false"
                    :auto-save="true"
                    @cancel="isEditingCase = false"
                    @save="onCaseChange"
                />

                <template v-else>
                    <div class="text-info">Mohon untuk menunggu indikasi dari DPJP</div>

                    <a-button v-if="!canOpenWorkingFormat()" class="mt-10" type="secondary" @click="isEditingCase = true">
                        Edit / Tambah Kasus
                    </a-button>
                </template>
            </div>

            <!-- Status menunggu partner indikasi DPJP -->
            <div v-if="data.is_partner && data.trx_status=='3-admitted' && data.partner_trx_status === '3-indicated' || data.koas_resident_code2 && !data.is_partner && data.partner_trx_status=='3-admitted' && data.trx_status === '3-indicated'"
                 style="text-align: center; margin-top: 20px"
                 class="vertical-flex flex-center"
            >
                <EditCase
                    v-if="isEditingCase && !canOpenWorkingFormat()"
                    :data="data"
                    :teaching-materials="filteredTeachingMaterials(data.departement_code, data)"
                    :can-edit-former="false"
                    :auto-save="true"
                    @cancel="isEditingCase = false"
                    @save="onCaseChange"
                />

                <template v-else>
                    <div class="text-info">Mohon untuk menunggu partner diindikasi oleh DPJP</div>

                    <a-button v-if="!canOpenWorkingFormat()" class="mt-10" type="secondary" @click="isEditingCase = true">
                        Edit / Tambah Kasus
                    </a-button>
                </template>
            </div>

            <div v-if="data.working_format_status === '3-rejected'" style="text-align: center; margin-top: 20px">
                <EditCase
                    v-if="isEditingCase"
                    :data="data"
                    :teaching-materials="filteredTeachingMaterials(data.departement_code, data)"
                    :can-edit-former="false"
                    :auto-save="true"
                    @cancel="isEditingCase = false"
                    @save="onCaseChange"
                />

                <template v-else>
                    <template v-if="data.is_partner">
                        <div class="text-info">Mohon tunggu partner koas mengisi format kerja</div>
                    </template>

                    <template v-else>
                        <div class="text-info text-info-error">Format kerja ditolak oleh DPJP. Silahkan untuk diperbaiki</div>
                    </template>

                    <a-button v-if="!canOpenWorkingFormat()" class="mt-10" type="secondary" @click="isEditingCase = true">
                        Edit / Tambah Kasus
                    </a-button>
                </template>
            </div>

            <!-- Status menunggu format kerja disetujui DPJP -->
            <div v-if="data.working_format_status=='3-request'" style="text-align: center; margin-top: 20px">
                <template v-if="data.is_partner">
                    <div class="text-info">Mohon tunggu partner koas mengisi format kerja</div>
                </template>

                <template v-else>
                    <div class="text-info">Mohon untuk menunggu DPJP menyetujui format kerja</div>
                </template>
            </div>

            <!-- Status format kerja telah disetujui DPJP atau koas telah order ulang BMHP -->
            <div v-if="canRequestTreatmentAction()" style="text-align: center; margin-top: 20px">
                <a-button class="mt-10" type="primary" @click="requestTreatmentAction()">
                    Ajukan Selesai Tindakan Perawatan
                </a-button>
            </div>

            <!-- Status menunggu tindakan perawatan disetujui DPJP -->
            <div v-if="!data.is_partner && data.trx_status=='4-request' || data.is_partner && data.partner_trx_status=='4-request'" style="text-align: center; margin-top: 20px">
                <div class="text-info">Mohon untuk menunggu DPJP menyetujui tindakan perawatan</div>
            </div>

            <!-- Status menunggu tindakan perawatan disetujui DPJP -->
            <div v-if="!data.is_partner && data.trx_status=='4-accepted' || data.is_partner && data.partner_trx_status=='4-accepted' && data.trx_status.substr(0, 1) != 5" style="text-align: center; margin-top: 20px">
                <div class="text-info text-info-success">DPJP telah menyetujui tindakan perawatan</div>

                <div style="margin-top: 10px">
                    <div class="text-info text-info-warning" v-if="!data.partner_done">Menuggu partner menyelesaikan tindakan</div>
                </div>
            </div>

            <!-- Status selesai -->
            <div v-if="data.trx_status=='5-done'" style="text-align: center; margin-top: 20px">
                <div class="text-info text-info-success">Selesai</div>

                <div style="margin-top: 10px">
                    <div class="text-info text-info-warning" v-if="!data.partner_done">Partner belum menyelesaikan tindakan</div>
                </div>
            </div>

            <!-- Status DPJP menolak tindakan perawatan -->
            <div v-if="!data.is_partner && data.trx_status === '4-rejected' || data.is_partner && data.partner_trx_status === '4-rejected'" style="text-align: center; margin-top: 20px">

                <div style="text-align: center" class="mb-10">
                    <div class="text-info text-info-error">{{ getLastLog(data.is_partner).description }}</div>
                </div>

                <a-button class="mt-10" type="primary" @click="reorderBmhp()">
                    Order Ulang BMHP
                </a-button>
            </div>

            <!-- Status aborted -->
            <div v-if="data.trx_status=='5-aborted'" style="text-align: center; margin-top: 20px">
                <div class="text-info text-info-error">Selesai. DPJP tidak mengizinkan untuk melanjutkan.</div>
            </div>

            <div v-if="canOpenWorkingFormat() && data.trx_status !== '1-accepted'" style="text-align: center; margin-top: 20px" class="vertical-flex flex-center">
                <EditCase
                    v-if="isEditingCase"
                    :data="data"
                    :teaching-materials="filteredTeachingMaterials(data.departement_code, data)"
                    :can-edit-former="false"
                    :auto-save="true"
                    @cancel="isEditingCase = false"
                    @save="onCaseChange"
                />

                <template v-else>
                    <template v-if="data.is_partner && data.working_format_status !== '3-request'">
                        <div class="text-info">Mohon tunggu partner koas mengisi format kerja</div>
                    </template>

                    <template v-else-if="!data.is_partner">
                        <a-button class="mt-10" type="primary" @click="openFormatKerja()">
                            Buka Laporan Format Kerja
                        </a-button>
                    </template>

                    <a-button class="mt-10" type="secondary" @click="isEditingCase = true">
                        Edit / Tambah Kasus
                    </a-button>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

import BookingApi from "../../../repository/api/BookingApi";
import moment from "moment";
import EditCase from "./EditCase.vue";

export default {
    components: {EditCase},
    props: {
        'id': String
    },

    data() {
        return {
            data: {},

            form: {
                department_code: undefined,
                dpjp_code: undefined,
                note: "",
            },

            isEditingCase: false,

            // Table search query
            query: "",
        };
    },

    mounted() {
        this.getData()
    },

    methods: {
        bookDpjp(lateCanceled = false) {
            if (!this.form.department_code) {
                this.$swal({
                    icon: "warning",
                    text: "Silahkan pilih klinik terlebih dahulu",
                })

                return
            }
            else if (!this.form.dpjp_code) {
                this.$swal({
                    icon: "warning",
                    text: "Silahkan pilih DPJP terlebih dahulu",
                })

                return
            }

            this.$swal({
                icon: "question",
                text: "Apakah anda yakin ingin melakukan booking DPJP?",
                showDenyButton: true,
                confirmButtonText: 'Ya, saya yakin',
                denyButtonText: 'Ingin mengubah',
            })
                .then((result) => {
                    if (result.isConfirmed) {
                        BookingApi.bookDPJP(this.id, this.form.dpjp_code, this.form.department_code, lateCanceled)
                            .then((response) => {
                                this.$swal({
                                    icon: "success",
                                    title: "Berhasil booking",
                                })

                                this.getData()
                            })
                            .catch((e) => {
                                this.form.dpjp_code = undefined;
                                this.form.department_code = undefined;

                                if (e.status == 405) {
                                    this.$swal({
                                        icon: "warning",
                                        title: "Sudah Penuh",
                                        text: "Maaf, jadwal DPJP sudah penuh",
                                    });
                                }
                                else {
                                    this.$swal({
                                        icon: e.severity || "error",
                                        title: (e.severity || "error").toUpperCase(),
                                        text: e.message,
                                    });
                                }
                            })
                    }
                })
        },

        cancelDpjp(lateCanceled = false) {
            this.$swal({
                icon: "question",
                text: "Apakah anda yakin ingin membatalkan booking DPJP?",
                showDenyButton: true,
                confirmButtonText: 'Ya, saya yakin',
                denyButtonText: 'Batal',
            })
                .then((result) => {
                    if (result.isConfirmed) {
                        BookingApi.cancelDPJP(this.id, lateCanceled)
                            .then((response) => {
                                this.$swal({
                                    icon: "success",
                                    title: "Berhasil membatalkan DPJP",
                                })

                                this.form.department_code = undefined
                                this.form.dpjp_code = undefined

                                this.getData()
                            })
                            .catch((e) => {
                                this.$swal({
                                    icon: e.severity || "error",
                                    title: (e.severity || "error").toUpperCase(),
                                    text: e.message,
                                });
                            })
                    }
                })
        },

        requestCase(cases, byNotIndicated = false) {
            this.$swal({
                icon: "question",
                text: "Apakah anda yakin ingin mengajukan kasus?",
                showDenyButton: true,
                confirmButtonText: 'Ya, saya yakin',
                denyButtonText: 'Ingin mengubah',
            })
                .then((response) => {
                    if (response.isConfirmed) {
                        BookingApi.requestCase(this.id, cases, this.data.is_partner, byNotIndicated)
                            .then((response) => {
                                this.$swal({
                                    icon: "success",
                                    text: "Pengajuan kasus berhasil",
                                })

                                this.getData()
                            })
                            .catch((e) => {
                                this.form.case_id = ""
                                this.$swal({
                                    icon: e.severity || "error",
                                    title: (e.severity || "error").toUpperCase(),
                                    text: e.message,
                                })
                            })
                    }
                })
        },

        openFormatKerja() {
            BookingApi.openWorkingFormat(this.id)
                .then((response) => {

                    if (this.data.koas_resident_code2) {
                        this.$swal({
                            icon: "warning",
                            text: "Pastikan tindakan partner sudah diinput sebelum mengajukan format kerja",
                            confirmButtonText: 'OK',
                        })
                            .then((response) => {
                                if (response.isConfirmed) {
                                    this.getData()

                                    this.$router.push({
                                        name: 'FormatKerja',
                                        params: {id: this.data.booking_code}
                                    })
                                }
                            })
                            .catch((e) => {
                                this.$swal({
                                    icon: e.severity || "error",
                                    title: (e.severity || "error").toUpperCase(),
                                    text: e.message,
                                })
                            })
                    }
                    else {
                        this.$router.push({
                            name: 'FormatKerja',
                            params: {id: this.data.booking_code}
                        })
                    }
                })
                .catch((e) => {
                    this.form.case_id = ""
                    this.$swal({
                        icon: "error",
                        title: "ERROR",
                        text: e.message,
                    });
                })
        },

        requestTreatmentAction() {
            this.$swal({
                icon: "question",
                text: "Apakah anda telah menyelesaikan tindakan perawatan?",
                showDenyButton: true,
                confirmButtonText: 'Ya',
                denyButtonText: 'Batal',
            })
                .then((response) => {
                    if (response.isConfirmed) {
                        BookingApi.requestTreatmentAction(this.id, this.data.is_partner)
                            .then((response) => {
                                this.$swal({
                                    icon: "success",
                                    text: "Tindakan perawatan telah disubmit",
                                })

                                this.getData()
                            })
                            .catch((e) => {
                                this.form.case_id = ""
                                this.$swal({
                                    icon: e.severity || "error",
                                    title: (e.severity || "error").toUpperCase(),
                                    text: e.message,
                                })
                            })
                    }
                })
                .catch((e) => {
                    this.$swal({
                        icon: e.severity || "error",
                        title: (e.severity || "error").toUpperCase(),
                        text: e.message,
                    })
                })
        },

        reorderBmhp() {
            this.$swal({
                icon: "question",
                text: "Apakah anda ingin order ulang BMHP?",
                showDenyButton: true,
                confirmButtonText: 'Ya',
                denyButtonText: 'Batal',
            })
                .then((response) => {
                    if (response.isConfirmed) {
                        BookingApi.reorderBmhp(this.id, this.data.is_partner)
                            .then((response) => {
                                this.$swal({
                                    icon: "success",
                                    text: "Order ulang BMHP berhasil",
                                })

                                this.getData()
                            })
                            .catch((e) => {
                                this.form.case_id = ""
                                this.$swal({
                                    icon: e.severity || "error",
                                    title: (e.severity || "error").toUpperCase(),
                                    text: e.message,
                                })
                            })
                    }
                })
                .catch((e) => {
                    this.$swal({
                        icon: e.severity || "error",
                        title: (e.severity || "error").toUpperCase(),
                        text: e.message,
                    })
                })
        },

        getStatus() {
            BookingApi.getStatus()
                .then((response) => {
                    this.statusMap = response;
                })
                .catch((e) => {
                    this.$swal({
                        icon: e.severity || "error",
                        title: (e.severity || "error").toUpperCase(),
                        text: e.message,
                    })
                })
        },

        getData() {
            BookingApi.get(this.id, this.$store.getters['auth/user'].user.username)
                .then((response) => {
                    this.data = {
                        ...response,
                        // Kalau parner, statusnya ambil dari partner_trx_status
                        trx_status: response.is_partner ? response.partner_trx_status : response.trx_status,
                        partner_done: response.is_partner ? response.trx_status.startsWith('5') : !response.koas_resident_code2 || response.partner_trx_status && response.partner_trx_status.startsWith('5')
                    }

                    if (response.departement_code) {
                        this.form.department_code = response.departement_code
                    }
                })
                .catch((e) => {
                    this.$swal({
                        icon: e.severity || "error",
                        title: (e.severity || "error").toUpperCase(),
                        text: e.message,
                    });
                })
        },

        isPassed(row) {
            return (
                (
                    (row.trx_status.endsWith("accepted"))
                )
            )
        },

        onCaseChange() {
            this.isEditingCase = false
            this.getData()
        },

        // Helpers =================================
        // =========================================
        filteredTeachingMaterials(department_id, row) {
            const i = this.teachingMaterials.filter(item => {
                return item.department_id == department_id
            })

            if (row.case) {
                return i.filter(item => {
                    for (const c of row.case) {
                        if (c.status == 2 && item.id == c.case_id && row.is_partner == !!parseInt(c.is_partner)) {
                            return false
                        }
                    }

                    return true
                })
            }
            else {
                return i
            }
        },

        statusByCode(code) {
            const s = this.statusMap.find((x) => x.code === code);
            return s ? s.description : "-";
        },

        isNeedForAction(row) {
            return (
                (this.data.log.findIndex((x) => x.id === row.id) ===
                    this.data.log.length - 1)
            );
        },

        canOpenWorkingFormat() {
            return (this.data.trx_status === '3-indicated' && !this.data.working_format_status)
            || (this.data.working_format_status && this.data.working_format_status !== '3-accepted')
        },

        canRequestTreatmentAction() {
            if (this.data.is_partner)
                return (this.data.partner_trx_status === '3-indicated' && this.data.working_format_status)
                    || this.data.partner_trx_status === '4-reordered'
            else
                return (this.data.trx_status === '3-indicated' && this.data.working_format_status)
                    || this.data.trx_status === '4-reordered'
        },

        getLastLog(isPartner) {
            if (isPartner == null)
                return this.data.log[this.data.log.length - 1]
            else {
                const logs = this.data.log.filter(x => x.is_partner == isPartner)
                return logs[logs.length - 1]
            }
        },

        isTimeInside(startKoas, endKoas, startDpjp, endDpjp) {
            return endKoas.isAfter(startDpjp) && startKoas.isSameOrBefore(startDpjp) || endDpjp.isAfter(startKoas) && startDpjp.isSameOrBefore(startKoas)
        }
    },

    computed: {
        filteredDokter() {
            const dpjpHistory = this.data.dpjp_history
                .map(x => parseInt(x.dpjp_code))

            return this.dpjp.filter(item => {
                if (!item.id_departemen)
                    return false

                try {
                    const bookingTime = this.data.dental_unit_time
                    const bookingDate = this.data.booking_date

                    const day = moment(bookingDate).format('d')
                    const time = moment(bookingTime.substr(0, 5), 'HH:mm')
                    const timeEnd = moment(bookingTime.substr(9, 5), 'HH:mm')

                    const schedule = this.dpjpSchedule.find(x => {
                        return x.dpjp_id == item.id
                            && parseInt(x.active) === 1
                            && (x.day == day || x.date == bookingDate)
                            && this.isTimeInside(time, timeEnd, moment(x.start_time, 'HH:mm'), moment(x.end_time, 'HH:mm'))
                    })

                    const inHistory = dpjpHistory.includes(parseInt(item.id))

                    return schedule && item.id_departemen == this.form.department_code && !inHistory
                }
                catch (e) {
                    console.log(e)
                    return false
                }
            })
        },

        currentStep() {
            if (this.data.is_partner) {
                if (["0-init", "1-request", "1-rejected"].includes(this.data.trx_status)) {
                    return 0
                } else if (["1-accepted", "2-request", "2-rejected"].includes(this.data.trx_status)) {
                    return 1
                } else if (["2-accepted", "3-admitted", "3-indicated", "3-request", "3-rejected"].includes(this.data.trx_status)) {
                    return 2
                } else if (["3-accepted", "4-request", "4-rejected", "4-reordered"].includes(this.data.trx_status)) {
                    return 3
                } else {
                    return 5
                }
            }

            if (this.data.trx_status === '5-done') {
                return 5
            }
            else if (["3-opened", "3-request", "3-accepted", "3-rejected"].includes(this.data.working_format_status)) {
                return 3
            }
            else if (this.data.prev_trx_status) {
                if (["0-init", "1-request", "1-rejected"].includes(this.data.prev_trx_status)) {
                    return 0
                } else if (["1-accepted", "2-request", "2-rejected"].includes(this.data.prev_trx_status)) {
                    return 1
                } else if (["2-accepted", "3-admitted", "3-request", "3-rejected"].includes(this.data.prev_trx_status)) {
                    return 2
                } else if (["3-accepted", "4-request", "4-rejected", "4-reordered"].includes(this.data.prev_trx_status)) {
                    return 3
                } else {
                    return 5
                }
            }
            else {
                if (["0-init", "1-request", "1-rejected"].includes(this.data.trx_status)) {
                    return 0
                } else if (["1-accepted", "2-request", "2-rejected"].includes(this.data.trx_status)) {
                    return 1
                } else if (["2-accepted", "3-admitted", "3-indicated", "3-request", "3-rejected"].includes(this.data.trx_status)) {
                    return 2
                } else if (["3-accepted", "4-request", "4-rejected", "4-reordered"].includes(this.data.trx_status)) {
                    return 3
                } else {
                    return 5
                }
            }
        },

        statusMap() {
            return this.$store.getters['apiData/status']
        },

        groupedStatus() {
            const statuses = this.statusMap
            const grouped = [
                {
                    step: 1,
                    title: "Booking DPJP",
                    childs: [],
                },
                {
                    step: 2,
                    title: "Pengajuan Kasus",
                    childs: [],
                },
                {
                    step: 3,
                    title: "Format Kerja",
                    childs: [],
                },
                {
                    step: 4,
                    title: "Tindakan Perawatan",
                    childs: [],
                },
            ]

            for (const status of statuses) {
                const group = grouped.find(x => x.step == status.code.substr(0, 1))

                if (group) {
                    group.childs.push(status)
                }
            }

            return grouped
        },

        dpjp() {
            return this.$store.getters['apiData/dpjp']
        },

        dpjpSchedule() {
            return this.$store.getters['apiData/dpjpSchedule']
        },

        departements() {
            return this.$store.getters['apiData/department']
        },

        teachingMaterials() {
            return this.$store.getters['apiData/teachingMaterials']
        }
    },

    watch: {
        id() {
            this.getData()
        }
    }
}

</script>

<style lang="scss" scoped>

.container {
    margin-top: 10px;
}

.item-label {
    font-size: 13px;
    color: #1F1F1F;
}

.text-info {
    font-size: 15px;
    border: 1px solid #7c7c7c;
    display: inline-block;
    padding: 10px 15px;
    border-radius: 3px;
    color: #7c7c7c;
}

.text-info-error {
    border: 1px solid #bb5c2e;
    color: #bb5c2e;
}

.text-info-success {
    border: 1px solid #338bc5;
    color: #338bc5;
}

.text-info-warning {
    border: 1px solid #ef7f39;
    color: #ef7f39;
    margin-top: 10px;
}

.timeline-date {
    display: block;
    color: #888888;
    font-weight: normal;
}

.timeline-status {
    display: block;
}

.timeline-desc {
    display: block;
    font-weight: normal;
    font-size: 13px;
}

</style>

<style>
.ant-steps-item-icon {
    width: 26px;
    height: 26px;
    position: relative !important;
}

.ant-steps-icon {
    position: absolute !important;
    top: 4px !important;
    left: 7px !important;
}

.ant-steps-item-title {
    font-size: 14px;
}

.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {
    color: white !important;
}

</style>